import {EditTariffType} from '../model/ITariff';

const NUMERIC_FIELDS = [
    'price',
    'period',
    'monitor_min_check_interval_limit',
    'monitor_max_count_limit',
    'domain_monitor_max_count_limit',
    'location_max_count_limit',
    'status_pages_max_count_limit',
    'reports_max_count_limit',
    'server_max_count_limit',
    'server_alert_rules_max_count_limit',
    'telegram_chats_max_count_limit',
    'max_chats_max_count_limit',
    'webhook_max_count_limit',
    'additional_emails_max_count_limit',
] as const;

export const normalizeTariffData = (values: EditTariffType): EditTariffType => {
    const result = { ...values };
    NUMERIC_FIELDS.forEach((field) => {
        const value = result[field];
        const num = Number(value);
        result[field] = (Number.isFinite(num) ? num : 0) as never;
    });
    return result;
};